<h2>Netwerk van mensen</h2>

<p>HOE ZIT EEN LETS-GROEP IN ELKAAR?</p>

<div class="lets_cirkel">
   <span class="prent"><img SRC="./images/lets_prent_affiche-2400.jpg" alt="Lets cirkel" id="prent">
  </span>
    <span class="tekst">
        Miet is komen wonen in de streek. <br>
        Omdat ze nieuwe mensen wil leren kennen, <br>
        heeft ze zich aangesloten bij de LETS-groep van Regio Zottegem. <br>
        Via deze groep kent ze nu Lucienne. <br>
        <b>Lucienne</b> is al 1 jaar bij de groep aangesloten <br>
        en helpt <b>Jesse</b> af en toe bij haar huiswerk. <br>
         Ze wordt hiervoor gewaardeerd in ietsen. <br>
        Omdat ze zelf moeilijk te been is, helpt <b>Miet</b><br>
        &ndash; die niet zo ver van Lucienne woont&ndash; <br>
        haar graag bij het boodschappen doen. <br>
        Hiervoor wordt zij ook gewaardeerd in ietsen. <br>
        Miet moet veel op de computer werken, <br>
        maar aangezien zij daarmee soms wel problemen heeft, wil <b>Jan</b>, de computerbolleboos van de groep, <br>
        haar graag helpen tegen ietsen, &hellip;<br>
         Maar Jan is niet zo'n specialist in opruimen ;-) &hellip; <br>
         daarvoor kan hij dus de hulp van <b>Frieda </b> goed gebruiken.<br>
         Alles netjes maken is geen probleem voor Frieda , <br>
        maar ze is heel blij dat ze voor het invullen van die <br>
        moeilijke formulieren te rade kan gaan mij Mark.<br>
        Papierenwerk is Mark zijn ding &hellip; schilderen niet echt &hellip; <br>
        Maar gelukkig is Dede daar al om een handje te helpen. En &hellip; had je al door dat Jesse het dochtertje is van Dede?
        <br> 
        <br>Ziezo, de cirkel is rond !
        <br>Bij het echte LETSen zal het natuurlijk geen mooie cirkel zijn,<br>
        het zal eerder een web van transacties tussen de LETSers zijn.
    </span>
</div>
<style  scoped>
    .lets_cirkel{
        display: flex;
        margin: 20px 0;
    }

   .prent {
       width: 432px;
   } 
   .tekst {
       width: 100%;
   }

   #prent {
       width: 100%;
       height: auto;
   }
</style>
